Vendd.Scripts.load(function () {

    var initialLaterCall = false;

    var $wrapper = $('.x-manufacturer-list'),
        wrapper,
        $configuration,
        configuration,
        $letterList = $(".horizontal-link-list"),
        letterList,
        isScrolled = false;

    var model = null;

    if ($wrapper.length < 1)
        return;


    wrapper = $wrapper.get(0);
    letterList = $letterList.get(0);

    $configuration = $('#configuration', $wrapper);
    configuration = $configuration.text();
    $configuration.remove();

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

    var loading = false,
        hasNext = true;

    wrapper.loading = function (loading) {
        if (loading === true) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    function wrapBoxes($boxes, grouping, rowSize, lastItem) {
        var items = [],
            currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "index" + currentIndex;
            cssClass += (currentIndex % 2) ? " odd" : " even";
            cssClass += (i === $boxes.length - 1) ? " last" : "";
            cssClass += currentIndex % rowSize === 0 ? " row-first" : "";
            cssClass += (currentIndex + 1) % rowSize === 0 ? " row-last" : "";

            li.append($boxes.eq(i)).addClass(cssClass).attr('data-index', currentIndex);

            items.push(li);

            currentIndex++;
        };

        return items;
    }

    wrapper.onSuccess = function (envelope) {

        model = envelope.message.data.model;
        if (model.Items.length === 0) {
            hasNext = false;
            return;
        } else {
            hasNext = true;
        };

        //enable letter-list
        letterList.init(model.Letters);

        var html = Vendd.Handlebars.parse("manufacturerList", model);

        var $html = $(html),
            $list = $('> ul', $wrapper),
            $boxes,
            items, lastItem, grouping, rowSize;

        if (initialLaterCall) {
            $list.empty();
            initialLaterCall = false;
        };
        configuration = $('#configuration', $html).text();
        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($html));

        $boxes = $('.x-manufacturer-box', $html);

        lastItem = $list.children().last();
        grouping = $html.data('grouping');
        rowSize = 3;

        items = wrapBoxes($boxes, grouping, rowSize, lastItem);

        $list.append(items);

        wrapper.loading(false);
        loading = false;
    };

    wrapper.onFailure = function (envelope) {
        if (envelope.message.data.list !== wrapper)
            return;

        wrapper.loading(false);
        loading = false;
    };

    wrapper.update = function () {
        if (loading || hasNext === false)
            return;

        loading = true;
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetNextPage(wrapper, configuration, 'manufacturerList'));
    };

    if ($letterList.length > 0) {
        letterList.init = function (model) {
            if (model == undefined)
                return false;

            var counter = 0;
            $.each(model, function (idx, item) {
                var $this = item;
                var $elem = $letterList.find("ul:eq(" + counter + ")");
                $.each($this, function (idx, item) {
                    if (item.IsActive === true) {
                        var $item = $elem.children(":eq(" + idx + ")");
                        var html = $item.html();

                        if (!$item.hasClass("active")) {
                            var $link = $("<a>").html(html).data('letters', item.LetterString);
                            $item.html("").addClass("active").append($link);
                        }
                    }
                });
                counter++;
            });

            //check if selected show clear link
            if ($letterList.find(".selected").length > 0)
                $letterList.find(".clearValues").addClass("show");
            else
                $letterList.find(".clearValues").removeClass("show");
        }

        $(".clearValues").on("click", function () {
            $letterList.find(".selected a").trigger("click");
        });

        letterList.init();
    }
    if (isScrolled) {
        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, wrapper, wrapper.onSuccess);
        Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPageFailure, wrapper, wrapper.onFailure);
    }

    $letterList.on("click", "li a", function (e) { //horizontal list functionality, click to highlight, click again to remove the highlighted value.

        var that = e.currentTarget;
        var $that = $(that);
        var $thatParent = $that.parent();

        var filterValue = [];
        if (isScrolled) {
            if (configuration) {
                if ($thatParent.hasClass("selected")) {
                    $thatParent.removeClass("selected");
                } else {
                    $thatParent.siblings().removeClass("selected");
                    $thatParent.addClass("selected");

                    var dataLetters = $that.data('letters');
                    if (dataLetters.length > 0) {
                        filterValue = dataLetters.indexOf(',') ? dataLetters.split(',') : [dataLetters];
                    }
                }

                //configure parameters for filtering by letter
                var configurationTxt = JSON.parse(configuration);
                configurationTxt.LoaderOptions.FirstLettersFilter = filterValue;
                configurationTxt.LoaderOptions.PageNumber = 0;

                configuration = JSON.stringify(configurationTxt);

                initialLaterCall = true;

                //publish message to call the new markup with the provided filtering
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetNextPage(null, configuration));
            }
        } else {

            if (!$that.parent().hasClass('active')) return;
            filterValue = "";
            if ($that.parent().hasClass("selected")) {
                //$('#manufacturer-letter-applied').removeClass('active').html('');
                $that.parent().removeClass("selected");
                updateSelectedManufacturers($wrapper, false);
            } else {
                //$('#manufacturer-letter-applied').addClass('active').html($this.parent().data('letter'));
                $('li', $letterList).removeClass("selected");
                $that.parent().addClass("selected");
                filterValue = $that.get(0).innerText;
                updateSelectedManufacturers($wrapper, true, filterValue);
            }
        }
    });
    if (configuration) {
        if (isScrolled) {
            $(window).scroll($.debounce(300, function () {
                if ($(window).scrollTop() >= $(document).height() - $(window).height() - $('.footer-region').height() - 500) {
                    wrapper.update();
                };
            }));
        }
    }

    function updateSelectedManufacturers(container, apply, filter) {

        var $boxes = $('> ul > li', container);
        var button = $('.clearValues', container.closest('.inner-area'));
        if (apply) {
            $boxes.each(function (index, box) {
                var $box = $(box),
                    title = String($box.data('title')).trim();
                if (filter === '#' || filter === '0-9' ) {
                    if (isNaN(title[0]) && title[0] != '#') {
                        $box.addClass('hidden');
                    } else {
                        $box.removeClass('hidden');
                    }
                } else {
                    if (title[0].toUpperCase() == filter) {
                        $box.removeClass('hidden');
                    } else {
                        $box.addClass('hidden');
                    }
                }
            });

            button.addClass('show');
        } else {
            $boxes.removeClass('hidden');
            button.removeClass('show');
        }
    }

});